import { createUserManager, loadUser } from 'redux-oidc';
import { store } from '../redux/store';

let userManager;

export const setupUserManager = function(settings) {
    if (settings && !userManager) {
        const config = {
            client_id: settings.webClientId,
            redirect_uri: `${window.location.protocol}//${window.location.host}/callback`,
            response_type: 'id_token token',
            scope: 'openid profile ss100',
            authority: settings.authUrl,
            post_logout_redirect_uri: `${window.location.protocol}//${window.location.host}/`,
            silent_redirect_uri: `${window.location.protocol}//${window.location.host}/silent_renew.html`,
            automaticSilentRenew: true,
            filterProtocolClaims: true,
            loadUserInfo: true
        };
        userManager = createUserManager(config);
        loadUser(store, userManager);
    }
}

export { userManager };
